module.exports = __webpack_public_path__ + "static/assets/a23104f047a9a42c9068f7f340112bd6.png";